import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Wand2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export const PROCESS_TYPES = [
  ["summary", "Samenvatting"], ["bullets", "Bulletpoints"], ["article", "Kennisartikel"], ["sop", "Werkinstructie (SOP)"],
];

// Round O — "Verwerk als" for the memo's owner and admins (the server enforces it too). The transcript never changes.
export const ProcessPicker = ({ memo, onDone, testId }) => {
  const [busy, setBusy] = useState(null);
  const run = async (type) => {
    setBusy(type);
    try {
      const { data } = await api.post(`/recordings/${encodeURIComponent(memo.id)}/process`, { transform_type: type });
      onDone(data);
      toast.success("Memo opnieuw verwerkt.");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(null);
    }
  };
  return (
    <div className="mb-3 flex flex-wrap items-center gap-2" data-testid={testId}>
      <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-tw-muted inline-flex items-center gap-1">
        <Wand2 size={11} strokeWidth={2.5} /> Verwerk als
      </span>
      {PROCESS_TYPES.map(([type, label]) => {
        const current = memo.processed_text && memo.transform_type === type;
        return (
          <button key={type} type="button" disabled={!!busy} onClick={() => run(type)} aria-pressed={!!current}
            data-testid={`${testId}-${type}`} data-current={current ? "true" : "false"}
            className={`tw-press inline-flex items-center gap-1 font-mono text-[10px] uppercase tracking-[0.15em] px-2 py-1 border transition-colors duration-150 disabled:opacity-50 ${current ? "border-tw-yellow text-tw-yellow" : "border-tw text-tw-muted hover:text-white hover:border-white"}`}>
            {busy === type && <Loader2 size={11} className="animate-spin" />}{label}{current && " · nu"}
          </button>
        );
      })}
    </div>
  );
};
